export enum PDFTitles {
  CompanyInformation = 'COMPANY INFORMATION',
  JobRequirementsDescription = 'JOB REQUIREMENTS & DESCRIPTION',
  CompensationBenefits = 'COMPENSATION & BENEFITS',
  CulturalFit = 'CULTURAL FIT & SOFT SKILLS',
  RecruitmentProcess = 'RECRUITMENT PROCESS',
  FeeSchedule = 'FEE SCHEDULE'
}

export enum Dictionaries {
  Language = 'LANGUAGE',
  JobStatus = 'JOB_STATUS_CW',
  Industry = 'INDUSTRY',
  ClientCountry = 'CLIENT_COUNTRY',
  LanguageLevel = 'LANGUAGE_LEVEL',
  Skillset = 'SKILLSET',
  ApplicantStatus = 'APPLICANT_STATUS',
  ClientPrivatePublic = 'CLIENT_PRIVATE_PUBLIC',
  ClientStatus = 'CLIENT_STATUS',
  ClientDomesticOver = 'CLIENT_DOMESTIC_OVER',
  ClientYearsInBus = 'CLIENT_YEARS_IN_BUS',
  JobType = 'JOB_TYPE',
  PayrollRates = 'PAYROLL_RATES',
  JobseekerStage = 'JOBSEEKER_STAGE',
  Education = 'EDUCATION',
  Study = 'STUDY',
  JobShift = 'JOB_SHIFT',
  ImmigrationRoutes = 'IMMIGRATION_ROUTES',
  SourcePlatform = 'SOURCE_PLATFORM',
  JobseekerStageTag = 'JOBSEEKER_STAGE_TAG',
  ApplicationStage = 'APPLICATION_STAGE',
  ApplicationStageTag = 'APPLICATION_STAGE_TAG',
  JobFeeStructure = 'JOB_FEE_STRUCTURE',
  ApplicationStageFlow = 'APPLICATION_STAGE_FLOW',
  JobseekerStageFlow = 'JOBSEEKER_STAGE_FLOW',
  ClientTier = 'CLIENT_TIER',
  ApplicationStageClient = 'APPLICATION_STAGE_CLIENT',
  ApplicationStageClientTag = 'APPLICATION_STAGE_CLIENT_TAG',
  ApplicationClientStageFlow = 'APPLICATION_CLIENT_STAGE_FLOW',
  JobClientStatusFlow = 'JOB_CLIENT_STATUS_FLOW',
  JobseekerAvailabilityStatus = 'JOBSEEKER_AVAILABILITY_STATUS',
  FeedbackCategory = 'FEEDBACK_CATEGORY'
}

export enum ClientDictionaries {
  ClientApplicationStage = 'APPLICATION_STAGE_CLIENT'
}

export enum RequestStatus {
  Idle = 'idle',
  Loading = 'loading',
  Succeeded = 'succeeded',
  Failed = 'failed'
}

export enum OptionTileTypes {
  BackCheck = 'back check',
  Benefits = 'benefits',
  DrugTest = 'drug test',
  TFA = 'TFA'
}

export enum BusDevDepartments {
  TalentAcquisitionAndAce = 'TALENT_ACQUISITION_AND_ACE',
  Finance = 'FINANCE',
  SalesAndBusinessDevelopment = 'SALES_AND_BUSINESS_DEVELOPMENT',
  LegalAndCompliance = 'LEGAL_AND_COMPLIANCE',
  EngineeringAndProduct = 'ENGINEERING_AND_PRODUCT',
  Marketing = 'MARKETING',
  Clients = 'CLIENTS',
  Ambassadors = 'AMBASSADORS'
}

export enum GlobalModules {
  AdminModule = 'ADMIN_MODULE',
  ClientsAndJobsModule = 'CLIENTS_AND_JOBS_MODULE',
  JobseekersAndApplicationsModule = 'JOBSEEKERS_AND_APPLICATIONS_MODULE',
  AceModule = 'ACE_MODULE',
  FinancialsModule = 'FINANCIALS_MODULE',
  AmbassadorsModule = 'AMBASSADORS_MODULE'
}

export enum UserAttachmentTypes {
  UserAvatar = 'USER_AVATAR',
  ClientContract = 'CLIENT_CONTRACT'
}

export enum ClientAttachmentTypes {
  UserAvatar = 'USER_AVATAR'
}

export enum JobseekerAttachmentTypes {
  OfferLetter = 'OFFER_LETTER',
  Passport = 'PASSPORT',
  IdCard = 'ID_CARD',
  Visa = 'VISA',
  WorkPermit = 'WORK_PERMIT',
  CV = 'CV',
  UserPrivateDocument = 'USER_PRIVATE_DOCUMENT',
  DriverLicense = 'DRIVER_LICENSE',
  OtherJobseekerDocuments = 'OTHER_JOBSEEKER_DOCUMENTS',
  JobseekerPhoto = 'JOBSEEKER_PHOTO'
}

export enum IndependentContractorAttachmentTypes {
  IcContract = 'IC_CONTRACT'
}

export enum PartnerAttachmentTypes {
  PartnerContract = 'PARTNER_CONTRACT'
}

export enum AmbassadorAttachmentTypes {
  AmbassadorContract = 'AMBASSADOR_CONTRACT'
}

export enum JobAttachmentTypes {
  TaoContract = 'TAO_CONTRACT',
  ExtraPaperWork = 'EXTRA_PAPERWORK',
  JobImage = 'JOB_IMAGE'
}

export enum JobStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE',
  InReview = 'IN_REVIEW'
}

export enum CreateJobFlow {
  Free = 'free',
  Paid = 'paid',
  PaymentRequired = 'paymentRequired'
}

export enum CreateJobFlowModalStep {
  FreeJobs = 'freeJobs',
  AddPayment = 'addPayment'
}

export enum SidebarContentTypes {
  JobView = 'jobView',
  JobseekerView = 'jobseekerView',
  JobsFilters = 'jobsFilters',
  JobseekersFilters = 'jobseekersFilters',
  ClientJobView = 'clientJobView',
  PreviewJobs = 'previewJobs',
  ApplicationsFilters = 'applicationsFilters',
  ApplicationView = 'applicationView',
  JobseekerAttachmentsView = 'jobseekerAttachmentsView',
  ApplicationAttachmentsView = 'applicationAttachmentsView',
  // We don't have filters for it for now, added for compatibility
  RecruitmentAnalyticsReportFilters = 'recruitmentAnalyticsReportFilters',
  OfferView = 'offerView',
  NotificationsView = 'notificationsView',
  ClosedHiresView = 'closedHiresView',
  FeedbackView = 'FeedbackView'
}

export enum AppModules {
  Applications = 'applications',
  Clients = 'clients',
  Jobs = 'jobs',
  Jobseekers = 'jobseekers',
  Ace = 'ace',
  Attachments = 'attachments',
  RecruitmentOverviewReport = 'recruitmentOverviewReport'
}

export enum JobseekerStage {
  AllJobseekerStage = 'ALL_JOBSEEKER_STAGE',
  ActiveCandidateJobseekerStage = 'ACTIVE_CANDIDATE_JOBSEEKER_STAGE',
  ProcessingJobseekerStage = 'PROCESSING_JOBSEEKER_STAGE',
  ClosedHireJobseekerStage = 'CLOSED_HIRE_JOBSEEKER_STAGE',
  TerminatedJobseekerStage = 'TERMINATED_JOBSEEKER_STAGE',
  InactiveJobseekerStage = 'INACTIVE_JOBSEEKER_STAGE',
  WaitingListJobseekerStage = 'WAITING_LIST_JOBSEEKER_STAGE'
}

/**
 * @attention Not Used
 */
export const JobseekerStageOptions: Partial<Record<JobseekerStage, string>> = {
  [JobseekerStage.AllJobseekerStage]: 'All candidates',
  [JobseekerStage.ActiveCandidateJobseekerStage]: 'Active Candidates',
  [JobseekerStage.ProcessingJobseekerStage]: 'Processing',
  [JobseekerStage.ClosedHireJobseekerStage]: 'Closed Hire',
  [JobseekerStage.TerminatedJobseekerStage]: 'Terminated',
  [JobseekerStage.WaitingListJobseekerStage]: 'Waiting List',
  [JobseekerStage.InactiveJobseekerStage]: 'Inactive'
};

export enum JobseekerTags {
  ClosedHireJobseekerStageOfferLetterSigned = 'CLOSED_HIRE_JOBSEEKER_STAGE_OFFER_LETTER_SIGNED',
  ClosedHireJobseekerStageOnSite = 'CLOSED_HIRE_JOBSEEKER_STAGE_ON_SITE',
  ClosedHireJobseekerStageReplacement = 'CLOSED_HIRE_JOBSEEKER_STAGE_REPLACEMENT',
  InactiveJobseekerStageUnder18 = 'INACTIVE_JOBSEEKER_STAGE_UNDER_18',
  InactiveJobseekerStageNotEligible = 'INACTIVE_JOBSEEKER_STAGE_NOT_ELIGIBLE',
  InactiveJobseekerStageNotInterested = 'INACTIVE_JOBSEEKER_STAGE_NOT_INTERESTED',
  InactiveJobseekerStageUnresponsive = 'INACTIVE_JOBSEEKER_STAGE_UNRESPONSIVE',
  InactiveJobseekerStageRiskProfile = 'INACTIVE_JOBSEEKER_STAGE_RISK_PROFILE',
  ProcessingJobseekerStageClientInterview = 'PROCESSING_JOBSEEKER_STAGE_CLIENT_INTERVIEW',
  ProcessingJobseekerStageInternalInterview = 'PROCESSING_JOBSEEKER_STAGE_INTERNAL_INTERVIEW',
  TerminatedJobseekerStageQuit = 'TERMINATED_JOBSEEKER_STAGE_QUIT',
  TerminatedJobseekerStageLaidOff = 'TERMINATED_JOBSEEKER_STAGE_LAID_OFF'
}

export enum ApplicationStage {
  AcceptedApplicationStage = 'ACCEPTED_APPLICATION_STAGE',
  ClientReviewApplicationStage = 'CLIENT_REVIEW_APPLICATION_STAGE',
  CompletedApplicationStage = 'COMPLETED_APPLICATION_STAGE',
  HiredApplicationStage = 'HIRED_APPLICATION_STAGE',
  DeclinedApplicationStage = 'DECLINED_APPLICATION_STAGE',
  InternalReviewApplicationStage = 'INTERNAL_REVIEW_APPLICATION_STAGE',
  NewApplicationStage = 'NEW_APPLICATION_STAGE'
}

export enum ApplicationFacetTypes {
  AllApplications = 'All Applications',
  ReadyForInterview = 'Ready for Interview',
  ReadyForOffer = 'Ready for Offer',
  Declined = 'Declined'
}

export enum ClientApplicationStages {
  AcceptedApplicationStageClient = 'ACCEPTED_APPLICATION_STAGE_CLIENT',
  ClientReviewApplicationStageClient = 'CLIENT_REVIEW_APPLICATION_STAGE_CLIENT',
  CompletedApplicationStageClient = 'COMPLETED_APPLICATION_STAGE_CLIENT',
  DeclinedApplicationStageClient = 'DECLINED_APPLICATION_STAGE_CLIENT',
  HiredApplicationStageClient = 'HIRED_APPLICATION_STAGE_CLIENT',
  NewApplicationStageClient = 'NEW_APPLICATION_STAGE_CLIENT'
}

export enum ApplicationTags {
  DeclinedApplicationStageClientRefused = 'DECLINED_APPLICATION_STAGE_CLIENT_REFUSED',
  AlreadyHired = 'ALREADY_HIRED',
  DeclinedApplicationStageJobseekerRefused = 'DECLINED_APPLICATION_STAGE_JOBSEEKER_REFUSED',
  DeclinedApplicationStageWithdrawn = 'DECLINED_APPLICATION_STAGE_WITHDRAWN',
  InternalReviewApplicationStageInternalInterview = 'INTERNAL_REVIEW_APPLICATION_STAGE_INTERNAL_INTERVIEW',
  InternalReviewApplicationStageProfileReview = 'INTERNAL_REVIEW_APPLICATION_STAGE_PROFILE_REVIEW',
  TerminatedApplicationStageBillingDispute = 'TERMINATED_APPLICATION_STAGE_BILLING_DISPUTE',
  TerminatedApplicationStageQuit = 'TERMINATED_APPLICATION_STAGE_QUIT',
  TerminatedApplicationStageLaidOff = 'TERMINATED_APPLICATION_STAGE_LAID_OFF',
  AceFilled = 'ACE_FILLED',
  AcceptedApplicationStageOfferLetterGiven = 'ACCEPTED_APPLICATION_STAGE_OFFER_LETTER_GIVEN',
  AcceptedApplicationStageOfferLetterSigned = 'ACCEPTED_APPLICATION_STAGE_OFFER_LETTER_SIGNED',
  HiredApplicationStageOfferLetterSigned = 'HIRED_APPLICATION_STAGE_OFFER_LETTER_SIGNED'
}

export enum AuthSteps {
  login = 'login',
  enterPassword = 'enterPassword',
  signUp = 'signUp',
  passwordUpdate = 'passwordUpdate',
  reSendRecoveryEmail = 'reSendRecoveryEmail',
  reSendSetUpPasswordEmail = 'reSendSetUpPasswordEmail',
  setUpPassword = 'setUpPassword'
}

export enum AttachmentsMenuType {
  Job = 'job',
  Client = 'client',
  Jobseekers = 'jobseekers',
  Application = 'application'
}

export enum EducationDegree {
  AssociatesDegree = 'ASSOCIATES_DEGREE',
  BachelorsDegree = 'BACHELORS_DEGREE',
  DoctorateDegree = 'DOCTORATE_DEGREE',
  HighSchoolDiploma = 'HIGH_SCHOOL_DIPLOMA',
  MastersDegree = 'MASTERS_DEGREE',
  NoSchoolEducation = 'NO_SCHOOL_EDUCATION',
  VocationalSchool = 'VOCATIONAL_SCHOOL'
}

export enum LanguageLevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE',
  Native = 'NATIVE',
  PreIntermediate = 'PRE_INTERMEDIATE'
}

export enum MultiSelectType {
  SkillSet = 'skillset',
  Languages = 'languages',
  Industries = 'industries',
  Shift = 'shift',
  JobType = 'jobType',
  LanguagesLevels = 'languagesLevels'
}

export enum MenuCategories {
  Home = 'Home',
  MyJobs = 'My Jobs',
  JobseekersApplications = 'Jobseekers & Applications',
  ACE = 'ACE',
  Financials = 'Financials',
  Ambassadors = 'Ambassadors',
  Attachments = 'Attachments'
}

export enum MimeTypes {
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf = 'application/pdf',
  jpg = 'image/jpeg',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  jpeg = 'image/jpeg',
  png = 'image/png'
}

export enum DialogModalTypes {
  Delete = 'delete'
}

export enum ErrorMessageType {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Info = 'info'
}

export enum JobFeeStructures {
  Ace = 'ACE',
  DirectHire = 'DIRECT_HIRE',
  FlatRate = 'FLAT_RATE',
  HourlyMarkup = 'HOURLY_MARKUP'
}

export enum JobFeeFieldNames {
  OnboardingFee = 'onboardingFee',
  MonthlyAceFee = 'monthlyAceFee',
  RetentionFee = 'retentionFee',
  DirectHireFee = 'directHireFee',
  HourlyMarkupFee = 'hourlyMarkupFee',
  FlatRateAmountFee = 'flatRateAmountFee'
}

export enum AlertType {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Premium = 'premium',
  Check = 'check'
}

export enum ProviderType {
  Local = 'local',
  Reset = 'reset'
}

export enum Departments {
  Clients = 'CLIENTS_WORKSPACE',
  Guest = 'GUEST'
}

export enum Submodules {
  Clients = 'clients',
  Jobs = 'jobs',
  Jobseekers = 'jobseekers',
  Applications = 'applications',
  Ace = 'ace'
}

export enum SpinnerSizes {
  Medium = 36,
  Large = 48
}

export enum AttachmentsOwnerEntities {
  Jobseeker = 'jobseeker',
  Application = 'application'
}

export enum BulkActions {
  ChangeStageJobs = 'changeStageJobs',
  AssignJoblioContactJobs = 'assignJoblioContactJobs',
  ChangeStageJobseekers = 'changeStageJobseekers',
  AssignRecruiterJobseekers = 'assignRecruiterJobseekers',
  UpdateContactDateJobseekers = 'UpdateContactDateJobseekers',
  UpdateImmigrationRouteJobseekers = 'updateImmigrationRouteJobseekers',
  InviteToJobJobseekers = 'inviteToJobJobseekers',
  ChangeApplicationStageApplications = 'changeApplicationStageApplications',
  UpdateStartDateApplications = 'updateStartDateApplications',
  UpdateSeparationDateApplications = 'updateSeparationDateApplications',
  ToggleInvoiceSentApplications = 'toggleInvoiceSentApplications',
  UpdateInvoiceDateApplications = 'updateInvoiceDateApplications'
}

export enum BulkActionResults {
  Success = 'SUCCESS',
  Error = 'ERROR'
}

export enum ClientWorkspaceRoles {
  Admin = 'CLIENT_ADMIN_ROLE',
  Billing = 'CLIENT_BILLING_ROLE',
  Manager = 'CLIENT_MANAGER_ROLE',
  TimeSheetContact = 'CLIENT_TIME_SHEET_CONTACT_ROLE'
}

export enum NotificationLevels {
  Alert = 'ALERT',
  Confirm = 'CONFIRMATIONAL',
  Error = 'ERROR',
  Info = 'INFORMATIONAL'
}

export enum ResponseErrorMessages {
  EmailExists = 'Email exists'
}

export enum ContactsFormType {
  Edit = 'edit',
  Add = 'add'
}

export enum PointsOfContactListType {
  Client = 'client',
  Job = 'job',
  TAO = 'TAO'
}

export enum ClientStatuses {
  Prospect = 'PROSPECT',
  Relating = 'RELATING',
  Discovering = 'DISCOVERING',
  Advocating = 'ADVOCATING',
  ContractSigned = 'CONTRACT_SIGNED',
  Service = 'SERVICE',
  Inactive = 'INACTIVE'
}

export enum ContactActionType {
  EDIT = 'edit',
  DELETE = 'delete'
}

export enum StageTransitionType {
  Application = 'application',
  Jobseeker = 'jobseeker',
  ClientApplication = 'clientApplication'
}

export enum SelectCardWrapperPermissions {
  JobEdit = 'jobEdit',
  JobPay = 'jobPay',
  JobUpgrade = 'jobUpgrade',
  JobView = 'jobView',
  JobDelete = 'jobDelete',
  JobCancelSubscription = 'jobCancelSubscription',
  JobReactivate = 'jobReactivate',
  ApplicationAccept = 'applicationAccept',
  ApplicationSendOffer = 'applicationSendOffer',
  ApplicationScheduleInterview = 'applicationScheduleInterview',
  ApplicationReject = 'applicationReject',
  JobseekerInviteToJob = 'jobseekerInviteToJob'
}
// Created a new one based on BE values, because it's different to our current app modules
export enum ClientTierAppModules {
  Jobs = 'JOBS',
  Applications = 'APPLICATIONS',
  Jobseekers = 'JOBSEEKERS',
  Ace = 'ACE',
  Analytics = 'ANALYTICS',
  Notes = 'NOTES'
}

export enum ClientTiers {
  Basic = 'BASIC',
  Concierge = 'CONCIERGE',
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Paid = 'PAID'
}

export enum JobseekerAvailabilityStatuses {
  ReadyToStart = 'READY_TO_START',
  Employed = 'EMPLOYED',
  ReceivingOffers = 'RECEIVING_OFFERS',
  Inactive = 'INACTIVE'
}

export enum ClientTierFeatures {
  Resumes = 'resumes',
  Filters = 'filters'
}

export enum ClientDomesticOverseas {
  Domestic = 'DOMESTIC',
  International = 'OVERSEAS',
  DomesticAndInternational = 'DOMESTIC_OVERSEAS'
}

export enum CardActions {
  JobEdit = 'JOB_EDIT',
  JobPay = 'JOB_PAY',
  JobUpgrade = 'JOB_UPGRADE',
  JobView = 'JOB_VIEW',
  JobDelete = 'JOB_DELETE',
  JobCancelSubscription = 'JOB_CANCEL_SUBSCRIPTION',
  JobReactivate = 'JOB_REACTIVATE',
  ApplicationAccept = 'APPLICATION_ACCEPT',
  ApplicationSendOffer = 'APPLICATION_SEND_OFFER',
  ApplicationScheduleInterview = 'APPLICATION_SCHEDULE_INTERVIEW',
  ApplicationReject = 'APPLICATION_REJECT',
  JobseekerInviteToJob = 'JOBSEEKER_INVIE_TO_JOB'
}

export enum OfferLetterSteps {
  OfferLetterNotSent = 'offerLetterNotSent',
  OfferLetterSent = 'offerLetterSent',
  WithdrawOfferConfirm = 'withdrawOfferConfirm',
  CustomOfferUpload = 'customOfferUpload'
}

export enum InterviewSchedulerView {
  Month = 'month',
  Week = 'week',
  Day = 'day'
}

export enum InterviewStep {
  InterviewRequestSent = 'INTERVIEW_REQUEST_SENT',
  SlotProvided = 'SLOT_PROVIDED',
  Scheduled = 'SCHEDULED',
  Withdrawn = 'WITHDRAWN',
  Declined = 'DECLINED'
}

export enum SubscriptionTypes {
  Concierge = 'CONCIERGE',
  Free = 'FREE',
  Paid = 'PAID'
}

export enum PaymentStatus {
  Active = 'active',
  Canceled = 'canceled',
  Unpaid = 'unpaid',
  Incomplete = 'incomplete',
  PastDue = 'past_due',
  Expired = 'expired',
  // not used
  IncompleteExpired = 'incomplete_expired',
  Paused = 'paused',
  Trialing = 'trialing'
}

export enum AppEnv {
  Ci = 'CI',
  Dev = 'DEV',
  Qa = 'QA',
  Stage = 'STAGE',
  Prod = 'PROD'
}

export enum FilterFields {
  SearchTerm = 'searchTerm',
  Country = 'country',
  State = 'state',
  City = 'city',
  HostCountry = 'hostCountry',
  Location = 'location',
  Citizenship = 'citizenship',
  User = 'user',
  BusDevId = 'busDevId',
  RecruiterIds = 'recruiterIds',
  AmbassadorId = 'ambassadorId',
  AceContactIds = 'aceContactIds',
  SelectedClientId = 'selectedClientId',
  Status = 'status',
  Stage = 'stage',
  Industry = 'industry',
  Skillset = 'skillset',
  DomesticOverseas = 'domesticOverseas',
  Benefits = 'benefits',
  DrugTest = 'drugTest',
  BackCheck = 'backCheck',
  Tfa = 'tfa',
  Education = 'education',
  Schedule = 'schedule',
  Languages = 'languages',
  ClientIds = 'clientIds',
  ScreeningCompleted = 'screeningCompleted',
  Locations = 'locations',
  JobseekerLocationsCountry = 'jobseekerLocationsCountry',
  JobseekerLocationsState = 'jobseekerLocationsState',
  JobseekerLocationsCity = 'jobseekerLocationsCity',
  MaxMatched = 'maxMatched',
  Days = 'days',
  Date = 'date',
  Fees = 'fees',
  ClientContactedCheck = 'clientContactedCheck',
  SeekerContactedCheck = 'seekerContactedCheck',
  Page = 'page',
  PageSize = 'pageSize',
  SortField = 'sortField',
  Order = 'order',
  Ace = 'ace',
  Tags = 'tags',
  JobIds = 'jobIds'
}

export enum MatchingTagTypes {
  Default = 'default',
  Simple = 'simple'
}

export enum OfferLetterStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Sent = 'SENT',
  Withdrawn = 'WITHDRAWN'
}

export enum ClientPaymentMethods {
  Card = 'card'
}

export enum StripeErrorCodes {
  ExpiredCard = 'expired_card'
}

export enum Region {
  US = 'US',
  EU = 'EU'
}

export enum GTMEvents {
  AuthLoginSuccess = 'cw_auth_login_success', //User successfully logs in
  PasswordSet = 'cw_password_set', //User successfully setup a password
  PasswordReset = 'cw_password_reset', //User successfully reset a password
  AuthLoginFail = 'cw_auth_login_fail', //Login attempt fails
  AuthLogout = 'cw_auth_logout', //User logs out
  SessionTimeout = 'cw_session_timeout', //User session expires
  DashboardView = 'cw_dashboard_view', //opens dashboard
  DashboardClickNavAnalytics = 'cw_dashboard_click_nav_analytics', //Clicks on top nav (Analytics)
  DashboardClickNavHome = 'cw_dashboard_click_nav_home', //Clicks on top nav (Homepage)
  DashboardClickNavJobs = 'cw_dashboard_click_nav_jobs', //Clicks on top nav (Jobs)
  DashboardClickNavApplications = 'cw_dashboard_click_nav_applications', //Clicks on top nav (Applications)
  DashboardClickNavJobseekers = 'cw_dashboard_click_nav_jobseekers', //Clicks on top nav (Jobseekers)
  DashboardClickViewAllJobs = 'cw_dashboard_click_view_all_jobs', //Client clicks on View all jobs
  DashboardClickViewAllApplications = 'cw_dashboard_click_view_all_applications', //Client clicks on View all applications
  FreeJobEdit = 'cw_free_job_edit', //User edits one of free jobs
  PaidJobEdit = 'cw_paid_job_edit_open', //Click “Edit” on a pro job
  FreeJobSubmitSuccess = 'cw_free_job_submit_success', //Job successfully created
  PaidJobFormSubmitSuccess = 'cw_paid_job_form_submit_success', //Job successfully created
  FreeJobDrafted = 'cw_free_job_drafted', //User saves a free job as a draft
  PaidJobDrafted = 'cw_paid_job_drafted', //User saves a paid job as a draft
  FreeJobSubmitFail = 'cw_free_job_submit_fail', //Job Submission error
  PaidJobFormSubmitFail = 'cw_paid_job_form_submit_fail', //Job Submission error
  FreeJobCanceled = 'cw_free_job_canceled', //User cancels editing a free job
  PaidJobCanceled = 'cw_paid_job_canceled', //User cancels editing a paid job
  PaidJobCreateStart = 'cw_paid_job_create_start', //User clicks “Create AI Job” to generate a paid
  PaidGenerateJobStart = 'cw_paid_generate_job_start', //Paid job generation initiated
  PaidGenerateJobSuccess = 'cw_paid_generate_job_success', //Paid job generation completed
  PaidGenerateJobFail = 'cw_paid_generate_job_fail', //Paid job generation failed
  JobFormSectionJobDescriptionRegenerate = 'cw_job_form_section_job_description_regenerate', //User clicks the magic button to REgenerate a job description
  JobFormEditSectionSkillsets = 'cw_job_form_edit_section_skillsets', //User edits a skillset section after AI generation
  JobFormEditSectionJobDescription = 'cw_job_form_edit_section_job_description', //User edits a job description section after AI generation
  JobFormTemplates = 'cw_job_form_templates', //User chooses to use one of the previously created jobs as a template
  JobListStatusEdit = 'cw_job_list_status_edit', //Client edits job status
  JobListView = 'cw_job_list_view', //Client opens Jobs page
  JobReactivate = 'cw_job_reactivate', //Client reactivates a job
  JobListViewSidebar = 'cw_job_list_view_sidebar', //Client opens jobs' sidebar
  JobListViewSidebarMatching = 'cw_job_list_view_sidebar_matching', //Client opens jobs' matches in the sidebar
  AiJobsListViewSidebarMatchingRecommendationsLoaded = 'ai_jobs_list_view_sidebar_matching_recommendations_loaded', //AI returns matches
  AiJobsListViewSidebarMatchingRecommendationInvite = 'ai_jobs_list_view_sidebar_matching_recommendation_invite', //User clicks invite for a job with one of the suggested candidates
  JobListFilters = 'cw_job_list_filters', //Client opens filters in Jobs page
  ApplicationsListFilters = 'cw_applications_list_filters', //Client opens filters in Applications page
  JobseekersListFilters = 'cw_jobseekers_list_filters', //Client opens filters in Jobseekers page
  JobListSorting = 'cw_job_list_sorting', //Client opens sorting in Jobs page
  ApplicationsListSorting = 'cw_applications_list_sorting', //Client opens sorting in Applications page
  JobseekersListSorting = 'cw_jobseekers_list_sorting', //Client opens sorting in Jobseekers page
  JobListSearch = 'cw_job_list_search', //Client uses search bar in Jobs page
  ApplicationsListSearch = 'cw_applications_list_search', //Client uses search bar in Applications page
  JobseekersListSearch = 'cw_jobseekers_list_search', //Client uses search bar in Jobseekers page
  JobListPaymentMethodAdd = 'cw_job_list_payment_method_add', //Client clicks on add a payment method
  JobListPaymentMethodUpdate = 'cw_job_list_payment_method_update', //Client clicks on update a payment method
  SubscriptionCanceled = 'cw_subscription_canceled', //Subscription canceled
  ApplicationsListView = 'cw_applications_list_view', //Opens applications list
  ApplicationsListViewSidebar = 'cw_applications_list_view_sidebar', //Client opens applications' sidebar
  ApplicationsListViewSidebarInterview = 'cw_applications_list_view_sidebar_interview', //Client opens applications's interview tab in the sidebar
  ApplicationsListViewSidebarOffer = 'cw_applications_list_view_sidebar_offer', //Client opens applications's offer tab in the sidebar
  ApplicationsListViewSidebarResume = 'cw_applications_list_view_sidebar_resume', //Client opens applications's resume tab in the sidebar
  ApplicationsListViewSidebarInterviewCanceled = 'cw_applications_list_view_sidebar_interview_canceled', //Client cancels the interview request
  ApplicationsListViewSidebarInterviewCustom = 'cw_applications_list_view_sidebar_interview_custom', //Client chooses to schedule interview himself (custom link)
  ApplicationsListViewSidebarInterviewJoblio = 'cw_applications_list_view_sidebar_interview_joblio', //Client chooses for Joblio to schedule interview
  ApplicationsListViewSidebarInterviewCustomSent = 'cw_applications_list_view_sidebar_interview_custom_sent', //Custom interview link sent
  ApplicationsListViewSidebarInterviewJoblioSent = 'cw_applications_list_view_sidebar_interview_joblio_sent', //Joblio's interview link is sent
  ApplicationsListViewSidebarInterviewSlotsSelected = 'cw_applications_list_view_sidebar_interview_slots_selected', //Clients selects the final availability slot
  ApplicationsListViewSidebarInterviewJoblioClickJoin = 'cw_applications_list_view_sidebar_interview_joblio_click_join', //Client clicks to join interveiw, if generated by Joblio
  ApplicationsListViewSidebarOfferCustom = 'cw_applications_list_view_sidebar_offer_custom', //Client chooses to send offer himself (custom template)
  ApplicationsListViewSidebarOfferCustomSend = 'cw_applications_list_view_sidebar_offer_custom_send', //Custom offer is sent
  ApplicationsListViewSidebarOfferJoblio = 'cw_applications_list_view_sidebar_offer_joblio', //Client chooses Joblio to send offer
  ApplicationsListViewSidebarOfferJoblioSent = 'cw_applications_list_view_sidebar_offer_joblio_sent', //Joblio offer is sent
  ApplicationsListViewSidebarOfferCancel = 'cw_applications_list_view_sidebar_offer_cancel', //Client cancels offer
  ApplicationsListViewProfile = 'cw_applications_list_view_profile', //Client previews application's jobseeker profile from the list
  ApplicationsListViewProfileCopyEmail = 'cw_applications_list_view_profile_copy_email', //Client clicks to copy applicant's email
  ApplicationsListViewProfileCopyPhone = 'cw_applications_list_view_profile_copy_phone', //Client clicks to copy applicant's phone number
  ApplicationsListViewJob = 'cw_applications_list_view_job', //Client previews application's job details from the list
  ApplicationsListViewResume = 'cw_applications_list_view_resume', //Client previews application's resume from the list
  ApplicationsListMenuAccept = 'cw_applications_list_menu_accept', //Client accepts application from the application's menu
  ApplicationsListMenuReject = 'cw_applications_list_menu_reject', //Client rejects application from the application's menu
  ApplicationsListMenuOffer = 'cw_applications_list_menu_offer', //Client sends offer letter for application from the application's menu
  ApplicationsListMenuInterview = 'cw_applications_list_menu_interview', //Client sends interview request for application from the application's menu
  JobseekersListView = 'cw_jobseekers_list_view', //Opens jobseeker page
  JobseekersProfileView = 'cw_jobseekers_profile_view', //Views jobseeker profile
  JobseekersProfileViewResume = 'cw_jobseekers_profile_view_resume', //Views jobseeker resume
  JobseekersListInvite = 'cw_jobseekers_list_invite', //Clicks to invite a jobseeker for a job
  JobseekersListInviteSent = 'cw_jobseekers_list_invite_sent', //Invite to job is sent
  JobseekersListInviteFailed = 'cw_jobseekers_list_invite_failed', //Invite to job is failed
  AnalyticsView = 'cw_analytics_view', //Client opens analytics screen
  AnalyticsFilterChange = 'cw_analytics_filter_change', //Changes date range / metric
  NotificationView = 'cw_notification_view', //Opens notifications panel
  NotificationClick = 'cw_notification_click', //Clicks a notification
  NotificationViewReadAll = 'cw_notification_view_read_all', //Clicks "read all" on all notifications
  NotificationViewArchive = 'cw_notification_view_archive' //Opens archived notifications
}

export enum HowItWorksActionTypes {
  StartJobsTour = 'startJobsTour',
  StartApplicationsTour = 'startApplicationsTour'
}

export enum GuideType {
  FullGuide = 'fullGuide',
  Applications = 'applications',
  Jobs = 'jobs'
}

export enum JobFormMode {
  Edit = 'edit',
  Create = 'create'
}

export enum SortField {
  Relevance = 'RELEVANCE',
  Newest = 'NEWEST',
  RecentlyEdited = 'RECENTLY_EDITED'
}
